import { render, staticRenderFns } from "./HexaPoint.vue?vue&type=template&id=08c88bc4&"
import script from "./HexaPoint.vue?vue&type=script&lang=js&"
export * from "./HexaPoint.vue?vue&type=script&lang=js&"
import style0 from "./HexaPoint.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HexaPoint.vue"
export default component.exports